<template lang="html">
	<div class="fx-modal" v-show="showModal">
		<div class="overlay">
			<div class="fx-modal-content">
				<slot name="content" v-if="type === 'simple'"></slot>

				<div v-else-if="type === 'form'">
					<div class="fx-modal-title clearfix">
						<div class="ci ci-info l">
							<i class="icon" :class="icon"></i>
						</div>
						<div class="text l" id="formModalLabel">
							<div class="fx-h6">{{ title }}</div>
							<div class="text-muted">{{ subtitle }}</div>
						</div>
						<button
							class="close"
							@click="closeModal()"
							aria-label="Close"
						>
							<span>&times;</span>
						</button>
					</div>
					<div class="fx-modal-body">
						<slot name="form"></slot>
					</div>
					<div class="fx-modal-foot">
						<button class="btn btn-primary" @click="submit()">
							{{ button }}
							<div class="lds-ring" v-show="isLoading">
								<div></div>
								<div></div>
								<div></div>
								<div></div>
							</div>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			default: 'form',
		},
		icon: {
			type: String,
			default: 'fa fa-user',
		},
		title: {
			type: String,
			default: '',
		},
		button: {
			type: String,
			default: 'Save',
		},
		subtitle: {
			type: String,
			default: '',
		},
	},
	watch: {
		show() {
			this.showModal = this.show;
		},
		loading() {
			this.isLoading = this.loading;
		},
	},
	data() {
		return {
			showModal: this.show,
			isLoading: this.loading,
		};
	},
	methods: {
		closeModal() {
			this.showModal = false;
			this.$emit('close', false);
		},
		submit() {
			this.$emit('submit');
		},
	},
};
</script>
